module.exports = __webpack_public_path__ + "static/media/wallet.2408572f.svg";